/**
 * Main App — Router setup with AuthProvider and ToastProvider.
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { ToastProvider } from './components/ToastProvider';
import { AppShell } from './components/AppShell';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { CTIDashboard } from './apps/cti/pages/CTIDashboard';
import { UploadCTI } from './apps/cti/pages/UploadCTI';
import { AgentWorkflow } from './apps/cti/pages/AgentWorkflow';
import { KnowledgeSearch } from './apps/cti/pages/KnowledgeSearch';
import { MitreMapping } from './apps/cti/pages/MitreMapping';
import { RiskScoring } from './apps/cti/pages/RiskScoring';
import { VectorStatus } from './apps/cti/pages/VectorStatus';
import { ReportGenerator } from './apps/cti/pages/ReportGenerator';
import { UserManagement } from './apps/cti/pages/UserManagement';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<CTIDashboard />} />
              <Route path="upload" element={<UploadCTI />} />
              <Route path="workflow" element={<AgentWorkflow />} />
              <Route path="search" element={<KnowledgeSearch />} />
              <Route path="mitre" element={<MitreMapping />} />
              <Route path="risk" element={<RiskScoring />} />
              <Route path="vectors" element={<VectorStatus />} />
              <Route path="reports" element={<ReportGenerator />} />
              <Route
                path="users"
                element={
                  <ProtectedRoute requiredRoles={['superadmin']}>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
